import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { WpsLinkSvg } from './WpsLinkSvg'

export const WpsLinkIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={WpsLinkSvg} {...props} />
}
